import {CreateAccessFormValidationSchema} from '@/features/accesses/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const AccessFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues?: Partial<CreateAccessFormValidationSchema>
}) => {
    const form = useForm<CreateAccessFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(CreateAccessFormValidationSchema),
        defaultValues: defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
